import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'e5core-ui-monitor-sla-completion',
  template: `
    <e5core-ui-monitor-sla-completion-highcharts (slaRangeInDays)="slaRangeInDays">
    </e5core-ui-monitor-sla-completion-highcharts>
  `
})
export class E5coreUiMonitorSlaCompletionComponent implements OnInit {

  @Input() slaRangeInDays = 28; // number
  @Input() startDate: Date; // Drop down menu for start date

  constructor() { }

  ngOnInit() {

  }


}
